
import Credentials from "./Credentials.js";
import CredentialsMap from "./CredentialsMap.js";
import { SubDomain } from "../SubDomain.js";

export default class CredentialsDomain extends SubDomain {
  
  constructor(domain, storageMap) {
    super(domain, Credentials.MODEL_NAME);
    this.storage = storageMap.CredentialsStorage;
  }

  list() {
    return this.storage.list;
  }

  findAll() {
    var items = this.list();
    var map = new CredentialsMap(this.domain);
    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      var obj = new Credentials(this.domain, item);
      map.add(obj);
    }
    return map;
  }

  findById(itemId) {
    var items = this.list();
    var item = null;
    for (var i = 0; i < items.length; i++) {
      item = items[i];
      if (super.toId(item) == itemId) {
        return new Credentials(this.domain, item);
      }
    }
    item = new Credentials(this.domain);
    item.withId(itemId);
    return item;
  }
  
  findByUser(user) {
    var items = this.list();
    var item = null;
    var obj = null;
    for (var i = 0; i < items.length; i++) {
      item = items[i];
      obj = item['User'];
      if (obj != null && obj['@rid'] == user.id()) {
        return new Credentials(this.domain, item);
      }
    }
    item = new Credentials(this.domain);
    return item;
  }
}